// extracted by mini-css-extract-plugin
export default {"Container":"InspectionView_Container__7KbY1","Main":"InspectionView_Main__4T+Zy","Centered":"InspectionView_Centered__SVbJg"};